import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { action } from "typesafe-actions";
import { talentApi } from "./../../api/talent/talent-service";
import { AppState } from "./../app-state";
import { ApplicationActionTypes } from "./application-types";
import { getUser } from "../auth/auth-actions";

export const changeUserLanguage = (language: string, user_id: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(ApplicationActionTypes.CHANGE_USER_LANGUAGE));
    try {
      await talentApi.updateUserLanguage(language, user_id);
      dispatch(
        action(
          ApplicationActionTypes.CHANGE_USER_LANGUAGE_SUCCESS,
          language
        )
      );
    } catch (error) {
      dispatch(
        action(ApplicationActionTypes.CHANGE_USER_LANGUAGE_ERROR, error)
      );
    }
  };
};

export const changeCompanyLanguage = (language: string, company_id: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE));
    try {
      await talentApi.updateCompanyLanguage(
        language,
        company_id
      );
      dispatch(
        action(
          ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE_SUCCESS,
          {
            i18n: language,
          }
        )
      );
    } catch (error) {
      dispatch(
        action(ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE_ERROR, error)
      );
    }
  };
};


export const changeCompanyCurrency = (currency: string, company_id: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(ApplicationActionTypes.CHANGE_COMPANY_CURRENCY));
    try {
      await talentApi.updateCompanyCurrency(
        currency,
        company_id
      );
      dispatch(
        action(
          ApplicationActionTypes.CHANGE_COMPANY_CURRENCY_SUCCESS,
          {
            currency: currency,
          }
        )
      );
      dispatch(getUser());
    } catch (error) {
      dispatch(
        action(ApplicationActionTypes.CHANGE_COMPANY_CURRENCY_ERROR, error)
      );
    }
  };


  

  
}
